import React from 'react';
import '../App.css';
import {render} from 'react-dom';
import abe from './gallery/abe.JPG';
import pete from './gallery/pete.PNG';
import blm from './gallery/blm.JPG';
import dc from './gallery/dc.JPG';
import jaw from './gallery/jaw.JPG';
import mary from './gallery/mary.PNG';
import {ExternalLink} from 'react-external-link';


function ArtGallery(props){
    return(
        <>
        <div className="artPage">
            <div className="initialText"><h1 className="artTitle">art.</h1></div>
            <div className="gallery">
                <img className = "gallerypic" src={blm} alt="" id="1" />
                <img className = "gallerypic" src={abe} alt="" id="2" />
                <img className = "gallerypic" src={pete} alt="" id="3"/>
                <img className = "gallerypic" src={mary} alt="" id="4"/>
                <img className = "gallerypic" src={dc} alt="" id="5"/>
                <img className = "gallerypic" src={jaw} alt="" id="6"/>
            </div> </div>
            <div className="artLower" style={{fontSize:"150%"}}>
                <div className="artBio"><p>Though I have always been an admirer of all forms of creativity,<br /> it was not until my early twenties that I was able to discern a way <br /> to personally involve myself in some form of abstract artistic medium.</p></div>
                <div className="checkIt2">
                    <p className="linkPara"><ExternalLink className="linkage2" href="http://joshdiesenhaus.com/art">check it.</ExternalLink></p>
                </div>
            </div>

        </>
    );
}

class Art extends React.Component {
    constructor(props){
        super(props);
    }
    
    render(){
        return(<>
            <div >
                
                
                {/* <img className = "gallerypic" src={abe} alt="abe" id="6"/> */}
                <ArtGallery style={{outerHeight:'100vh'}}/>
                
            </div>
        </>);
    }
}


export default Art;